export default __webpack_public_path__ + "static/media/app2-4.45d56615.jpg";